// extracted by mini-css-extract-plugin
export default {"label":"XE+b2eFAlECzAluGv1QG4Q=="};